import { useState } from "react";

const useModal = (initialData = null) => {
  const [show, setShow] = useState(false);
  const [data, setData] = useState(initialData);

  const open = (d = null) => {
    setData(d);
    setShow(true);
  };

  const close = () => {
    setData(null);
    setShow(false);
  };

  const toggle = () => setShow(prev => !prev);

  return { show, data, open, close, toggle, setData };
};

export default useModal;
